// Environment configuration for different deployment environments
const config = {
  development: {
    apiBaseUrl: process.env.REACT_APP_API_BASE_URL || '', // Empty to use the development proxy
    environment: 'development'
  },
  production: {
    apiBaseUrl: process.env.REACT_APP_API_BASE_URL || '', // Prefer the same-origin production proxy
    environment: 'production'
  }
};

// Get current environment
const currentEnv = process.env.NODE_ENV || 'development';

export default config[currentEnv] || config.development;
